var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42927 1.1969C8.75622 0.190651 10.1798 0.190652 10.5067 1.1969L11.7975 5.16951C11.9437 5.61952 12.3631 5.9242 12.8363 5.9242H17.0133C18.0713 5.9242 18.5113 7.2781 17.6553 7.89999L14.276 10.3552C13.8932 10.6333 13.733 11.1263 13.8792 11.5763L15.17 15.5489C15.497 16.5552 14.3453 17.3919 13.4893 16.77L10.11 14.3148C9.72718 14.0367 9.20884 14.0367 8.82604 14.3148L5.44673 16.77C4.59076 17.3919 3.43907 16.5552 3.76602 15.5489L5.0568 11.5763C5.20302 11.1263 5.04284 10.6333 4.66004 10.3552L1.28073 7.89999C0.424764 7.2781 0.864672 5.9242 1.9227 5.9242H6.09976C6.57292 5.9242 6.99228 5.61952 7.13849 5.16951L8.42927 1.1969Z",
    fill: "#FFD700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStars);
export default __webpack_public_path__ + "static/media/reviewStars.dc0028f9.svg";
export { ForwardRef as ReactComponent };